import { StateType } from 'data/types'
import format from 'date-fns/format'
import { createSelector } from 'reselect'

import instrument from '../Instrument/selectors'
import { TradesStateType } from './reducers'
import { FormattedTradeType, TradeType } from './types'

const formatTradeDate: (string) => string = (date) => format(date, 'HH:mm:ss')

const transform = (trade: TradeType): FormattedTradeType => ({
  created: formatTradeDate(trade.timestamp),
  priceChange: 'same',
  px: trade.price,
  qty: trade.qty
})

const getTrades = (state: StateType): TradesStateType => state.trades
const getAllRaw = (state: StateType) => getTrades(state).all

const getAll: (state: StateType) => Array<FormattedTradeType> = createSelector(
  getAllRaw,
  (trades) =>
    trades.map((trade, idx, arr) => {
      const formatted = transform(trade)

      if (arr.length <= idx + 1) {
        return formatted
      }

      if (trade.price > arr[idx + 1].price) {
        return {
          ...formatted,
          priceChange: 'increase'
        }
      }

      if (trade.price < arr[idx + 1].price) {
        return {
          ...formatted,
          priceChange: 'decrease'
        }
      }

      return formatted
    })
)

const getMostRecent: (state: StateType) => FormattedTradeType | undefined = createSelector(
  getAllRaw,
  instrument.getSymbolTyped,
  (trades) => {
    if (trades.length) {
      return transform(trades[0])
    }

    return undefined
  }
)

const isLoading: (state: StateType) => boolean = createSelector(
  getTrades,
  ({ all, subscribed }) => !subscribed && all.length === 0
)

export default {
  getAll,
  getMostRecent,
  isLoading
}
